import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FunctionsService } from '../../___LOGIC/__common/functions.service';
import { ResolverService } from '../../___LOGIC/__common/resolver.service';
import { GuiFlowService } from '../../___LOGIC/__gui/gui-flow.service';
import { ResponsiveService } from '../../___LOGIC/__gui/responsive.service';
import { BottomModalProviderService } from '../../___LOGIC/bottom-modal-provider.service';
import { ClientBoardResolver } from 'src/app/___LOGIC/resolvers/client-board.resolver';
import { ViewportService } from 'src/app/___LOGIC/__gui/viewport.service';
import { ApiService } from 'src/app/___LOGIC/__api/api.service';
import { ServiceProviderService } from 'src/app/___LOGIC/__providers/service-provider.service';

@Component({
  selector: 'app-cards-board',
  templateUrl: './cards-board.component.html',
  styleUrls: ['./cards-board.component.css']
})
export class CardsBoardComponent implements OnInit {

  @Input() clientCards; 
  statusArray = [
    {
      id: 1,
      status: 'lead',
      icon: 'fas fa-user',
      visible: true
    },
    {
      id: 2,
      status: 'videocall',
      icon: 'fas fa-headset',
      visible: true
    },
    {
      id: 3,
      status: 'minuta',
      icon: 'fas fa-doc',
      visible: true
    },
    {
      id: 4,
      status: 'budget',
      icon: 'fas fa-wallet',
      visible: true
    },
    {
      id: 5,
      status: 'accepted',
      icon: 'fas fa-user-check',
      visible: true
    },
    {
      id:6,
      status: 'doing',
      icon: 'fas fa-user-check',
      visible: true
    },
    {
      id: 7,
      status: 'done',
      icon: 'fas fa-user-check',
      visible: false
    },
    {
      id: 8,
      status: 'caseStudy',
      icon: 'fas fa-book-reader',
      visible: false
    },
    {
      id: 9,
      status: 'lost',
      icon: 'fas fa-ghost',
      visible: false
    },
    {
      id: 10,
      status: 'archive',
      icon: 'fas fa-ghost',
      visible: false
    },
    {
      id: 11,
      status: 'hold',
      icon: 'fas fa-ghost',
      visible: false
    }
  ];
  screenSizeInput;
  currentCard;
  showLongHealthChip = false;
  searchString;

  loading = false;
  error: string | null = null;
  items: any[] = [];
  user;

  constructor(private serviceProvider: ServiceProviderService,private commonFunctions: FunctionsService,private router: Router,private resolver: ResolverService,private guiFlow:GuiFlowService,
    private responsiveService: ResponsiveService,private modalBottomService: BottomModalProviderService,private clientBoardResolver: ClientBoardResolver,public vp: ViewportService,private api: ApiService) { }

  ngOnInit(): void {
    /* this.fetch(); */
  }

  fetch(): void {
    this.loading = true;
    this.error = null;
    this.api.getClientDashboardData('dashboard').subscribe({
      next: (res) => { this.items = res.items || []; this.loading = false; },
      error: (err) => { this.error = err?.error?.error || err.message; this.loading = false; }
    });

    /* this.api.getClientDetails(1).subscribe({
      next: (res) => { this.user = res.user || []; this.loading = false; },
      error: (err) => { this.error = err?.error?.error || err.message; this.loading = false; }
    }); */
  }

  isLoading(){
    return this.loading;
  }

  reloadDashboardData(){
    /* this.clientBoardResolver.resolve(null).subscribe(data => {
      this.clientCards = data.clientBoardData.data;
    }, err => {
      console.error('Error loading data:', err);
    }); */
  }

  changeStatusTo(newStatus,clientCard){
    this.commonFunctions.setSelectedClientId(clientCard.id);
    this.serviceProvider.changeStatus(newStatus,this.currentCard);
    /* let historic = {
      operation: 'changeStatus',
      previousObj: JSON.stringify({ status: this.currentCard.status}),
      newObj: JSON.stringify({ status: newStatus }),
      FK_ID_clientDetails: this.commonFunctions.getSelectedClientId(),
      FK_ID_asignee: this.resolver.getUserSessionData().id,
    };
    this.resolver.registerHistoric(historic,'register change status'); */
  }

  /* CLIENT INTERACTIONS */
  openDialog(clientCard): void {
    /* this.commonFunctions.setSelectedClientId(clientCard.id);
    this.resolver.getClientDetails(true); */
    this.router.navigateByUrl('/client-interactions/'+clientCard.id);
    
    /* const dialogRef = this.dialog.open(ModalListView, {
      data: {clientCard: clientCard},
      panelClass: 'my-modal-md'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    }); */
  }

  delete(card){
    this.resolver.delete(card,'deleteFollowUp');
    this.reloadDashboardData();
  }

  getLastContactDays(d2){
    return 0;
    /*     return Math.trunc(this.commonFunctions.getDaysRemaining(null,d2)); */
  }

  getVisibleStatus(){
    let res = [];
    for(let status of this.statusArray){
      if(status.visible){
        res.push(status);
      }
    }
    return res;
  }

  getNonVisibleStatus(){
    let res = [];
    for(let status of this.statusArray){
      if(status.visible == false){
        res.push(status);
      }
    }
    return res;
  }

  getMonthsRemaining(d1,d2){
    return this.commonFunctions.getMonthsRemaining(d1,d2);
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }

  // This has to get this user credentials
  newSession(cardData){
    debugger
  }

  getClientData(followUp){
    this.resolver.goToProfile(followUp);
  }

  hideColumn(st){
    st.visible = false;
    this.statusArray.sort((a, b) => a.id - b.id);
  }

  showColumn(st){
    st.visible = true;
    this.statusArray.sort((a, b) => a.id - b.id);
  }

  showLastContact(date){
    return  date != '0000-00-00';
  }

  changeAssignee(currentAssignee,followUpId){

  }

  copyToCLipboard(value){
    navigator.clipboard.writeText(value);
    /* this.guiFlow.openSimpleSnackBar('Copied to clipboard', '💾' ); */
  }

  goToUserDriveFolder(url){
    url?   window.open(url) : null;
  }

  openPackageDetailsSummary(chosenPackage): void {
    
  }

  goToUserProfile(followUp){
    /* this.serviceProvider.setCurrentClientCard(followUp);
    this.commonFunctions.setSelectedClientId(followUp.id);
    this.resolver.getClientDetails(true);
    this.resolver.getClientInteractions(true);
    this.currentCard.id = followUp.id;
    this.resolver.getClientChecklists(true);
    this.goToPage('profile/edit/'+followUp.id); */
  }

  cardSelect(cardData){
    this.currentCard = cardData;
  }

  generateHtmlId(clientCard){
    return 'client'+clientCard.id;
  }

  getClientCardsByStatus(p_status){
    let res = [];
    if(this.clientCards && this.clientCards.length>0){
      for(let clientCard of this.clientCards){
        if(clientCard.status === p_status){
          res.push(clientCard);
        }
      }
    }
    return res;
  }

  getTotalUnreadMessages(){
    return 0;
    /* return this.rootScope.getUnReadMessages(); */
  }

  openSearch(){
    this.modalBottomService.openBottomSheet();
  }

  openNewReminderModal(){

  }

  filterByAsignee(asignee){
    if(asignee == 'All'){
      this.clientCards = this.resolver.getDependencyRecords('getClientDashboardData');
    }else{
      this.clientCards = this.resolver.getDependencyRecords('getClientDashboardData');
      this.clientCards = this.clientCards.filter(obj => obj.assignee == asignee);
    }
  }

  filterByCity(city){
    if(city == 'All'){
      this.clientCards = this.resolver.getDependencyRecords('getClientDashboardData');
    }else{
      this.clientCards = this.resolver.getDependencyRecords('getClientDashboardData');
      this.clientCards = this.clientCards.filter(obj => obj.destination == city);
    }
  }
  

}
